export const PACKAGE_NAME = "@keystone/core" as const;

/**
 * MCP protocol version this codebase targets. Updated to the current stable spec
 * rev per ADR-0011. The MCP spec mandates this header on every request to a remote
 * server: `MCP-Protocol-Version: 2025-11-25`.
 *
 * Generated servers MUST also accept `2025-03-26` (the spec-defined back-compat
 * fallback for requests that omit the header) and SHOULD accept `2025-06-18` (the
 * prior rev we targeted) for back-compat with clients still on that version.
 * Source: spec/2025-11-25/basic/transports + ADR-0011.
 */
export const MCP_PROTOCOL_VERSION = "2025-11-25" as const;
export const MCP_PROTOCOL_VERSION_FALLBACK = "2025-03-26" as const;
export const MCP_PROTOCOL_VERSION_PRIOR = "2025-06-18" as const;
export const MCP_PROTOCOL_VERSIONS_ACCEPTED = [
  MCP_PROTOCOL_VERSION,
  MCP_PROTOCOL_VERSION_FALLBACK,
  MCP_PROTOCOL_VERSION_PRIOR
] as const;

export * from "./schemas/index.js";
export * from "./digest.js";
export * from "./llm.js";
export * from "./anthropic-client.js";
export * from "./mcp-apps-seam.js";
